import Constants from '../constants/constants';
import { dispatcher } from '../dispatcher/dispatcher';

import { storeUtils } from './util';

const { ActionTypes } = Constants;
var _events = new storeUtils.EventEmitter();
var Util = require('../util/converters');
var CHANGE_EVENT = 'change';
import { ServerActions } from '../actions/serverActions';
var AdminValidator = require('../util/adminValidation');
var _isOverride = false;

var _itemType = "";
var _items = [];
var _selectedSub;
var _newAdminItem;
var _isLoading = false;
var _error;
var _overrideUserValidity = {
    userIdValidity: null,
    userIdHelpMessage: "",
    subdivisionValidity: null,
    subdivisionHelpMessage: "",
    startMpValidity: null,
    startMpHelpMessage: "",
    endMpValidity: null,
    endMpHelpMessage: "",
    canSubmit: false
};
var _overrideReasonCodes = [];


var dispatchToken = dispatcher.register(function (action) {
    switch (action.type) {
        case ActionTypes.SET_ADMIN_ITEM_TYPE:
            _itemType = action.itemType;
            _events.trigger(CHANGE_EVENT);
            break;
        case ActionTypes.LOAD_ADMIN_ITEMS_DONE:
            _isLoading = false;
            _items = action.items;
            _events.trigger(CHANGE_EVENT);
            break;
        case ActionTypes.LOAD_ADMIN_ITEMS_ERROR:
            _isLoading = false;
            _error = action.error;
            _events.trigger(CHANGE_EVENT);
            break;
        case ActionTypes.LOAD_ADMIN_ITEMS_STARTED:
            _isLoading = true;
            _events.trigger(CHANGE_EVENT);
            break;
        case ActionTypes.CELL_UPDATED:
            _items[action.row][action.id] = action.value;
            _events.trigger(CHANGE_EVENT);
            break;
        case ActionTypes.OVERRIDE_REASON_CODES_LOADED:
            _overrideReasonCodes = action.codes;
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.SHOW_DEFAULT_TRACKS_VALUE_CHANGED:
            _isOverride = action.value;
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.NEW_ADMIN_ROW_ENTERED:
            if (action.data != null) {
                if (action.data.subdivision != null && action.data.subdivision != _selectedSub) {//Only get the sub details if the sub had changed
                    _selectedSub = action.data.subdivision
                    ServerActions.getSubdivisionDetails(action.data.subdivision);
                }
                _newAdminItem = action.data;
                _overrideUserValidity = AdminValidator.validateAdminInputRow(_itemType, action.data, action.buttonClicked);
            }
            _events.trigger(CHANGE_EVENT);
            break;
        case ActionTypes.NEW_OVERRIDE_SUBMITTED:
            _items.splice(0, 0, action.override);
            _newAdminItem = null;
            _events.trigger(CHANGE_EVENT);
            break;
        case ActionTypes.ADMIN_ITEM_SUBMIT_ERROR:
            _overrideUserValidity = Util.convertOverrideErrorsToClientFormat(action.errors);
            _events.trigger(CHANGE_EVENT);
            break;
        case ActionTypes.EXISTING_OVERRIDE_EXPIRED:
            var index = -1;
            if (index > -1) {
                _items[index] = action.override;
            }
            _events.trigger(CHANGE_EVENT);
            break;
        default:
        //no op
    }
});//end of dispatch token


//public api
export const adminStore = {
    dispatchToken,
    subscribe: _events.on,
    unsubscribe: _events.off,
    getItemType: function () { return _itemType; },
    getItems: function () { return _items; },
    isLoading: function () { return _isLoading; },
    getError: function () { return _error; },
    getOverride: function () { return _isOverride; },
    getOverrideReasonCodes: function () { return _overrideReasonCodes },
    getOverrideUserValidity: function () { return _overrideUserValidity },
    canSubmitAdminItem: function () { return _overrideUserValidity.canSubmit },
    getNewAdminItem: function () { return _newAdminItem }
};

